module.exports = __webpack_public_path__ + "static/media/toggle.8d18f070.svg";